import { AuthenticationLogList } from '../../../components/Report';

export function InvalidAccess() {
  return <AuthenticationLogList mode="invalidAccess" />;
}
